import { createSelector } from 'reselect';

export const getForgotPasswordEmail = state => state.forgotPassword.email;

export const getResetPasswordError = state => state.resetPassword.error;

export default createSelector([getForgotPasswordEmail, getResetPasswordError]);
